import { Navigate, useRoutes } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';
import Layout from '@/themes';
import Login from '@/pages/Login';
import Home from '@/pages/Home';
import Ambassador from '@/pages/Ambassador';
import AmbassadorAdd from '@/pages/Ambassador/Add';
import AmbassadorEdit from '@/pages/Ambassador/Edit';
import AmbassadorDetail from '@/pages/Ambassador/Detail';
import DataReport from '@/pages/DataReport';
import QrTracking from '@/pages/QrTracking';
import Surveys from '@/pages/Surveys';
import ManageUsers from '@/pages/ManageUsers';
import ManageUsersAdd from '@/pages/ManageUsers/Add';
import ManageUsersEdit from '@/pages/ManageUsers/Edit';
import ManageSite from '@/pages/ManageSite';
import ManageSiteAdd from '@/pages/ManageSite/Add';
import ManageSiteEdit from '@/pages/ManageSite/Edit';
import Logs from '@/pages/Logs';

function Router() {
  return useRoutes([
    { path: '/login', element: <Login /> },
    {
      path: '/',
      element: (
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      ),
      children: [
        { index: true, element: <Home /> },
        { path: 'ambassador', element: <Ambassador /> },
        { path: 'ambassador/add', element: <AmbassadorAdd /> },
        { path: 'ambassador/:id/edit', element: <AmbassadorEdit /> },
        { path: 'ambassador/:id', element: <AmbassadorDetail /> },
        { path: 'data-report', element: <DataReport /> },
        { path: 'qr-tracking', element: <QrTracking /> },
        { path: 'surveys', element: <Surveys /> },
        { path: 'manage-users', element: <ManageUsers /> },
        { path: 'manage-users/add', element: <ManageUsersAdd /> },
        { path: 'manage-users/:id/edit', element: <ManageUsersEdit /> },
        { path: 'manage-site', element: <ManageSite /> },
        { path: 'manage-site/add', element: <ManageSiteAdd /> },
        { path: 'manage-site/:id/edit', element: <ManageSiteEdit /> },
        { path: 'logs', element: <Logs /> },
      ],
    },
    { path: '*', element: <Navigate to="/" replace /> },
  ]);
}

export default Router;
